(function ($) {


    this.init = function () {
        this.BlogFilter();
    };


    /****************************************************************
     HOMEPAGE BANNER
    ****************************************************************/
    this.BlogFilter = function () {
        // read the incoming HTML to see if we have a URL variable - if so, then we've got work to do

        $("#catbutton").on("click", clickCategoryDropdown);

    }

    function clickCategoryDropdown() {
        
    }

    this.init();

})(jQuery);